import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const DashboardHandicraft = React.lazy(() => import('../screens/protected/Dashboard/index_handicraft'));
const DashboardCloth = React.lazy(() => import('../screens/protected/Dashboard/indexcloth'));
const DashboardSchool = React.lazy(() => import('../screens/protected/Dashboard/index_school'));
const DashboardIt = React.lazy(() => import('../screens/protected/Dashboard/index_it'));


const DashboardWrapper = () => {
    const user = useSelector((state: any) => state.user?.user);
  
    if (!user) return <Navigate to="/login" replace />; // Redirect if not logged in
  
    return (
      <Suspense fallback={<div>Loading dashboard...</div>}>
        {user.organization_category === 'Handicraft' && <DashboardHandicraft />}
      {user.organization_category === 'School' && <DashboardSchool />}
      {user.organization_category === 'IT' && <DashboardIt />}
      {user.organization_category === 'Cloth' && <DashboardCloth />}

      {/* Fallback in case organization_category doesn't match any known type */}
      {!['Handicraft', 'School', 'IT', 'Cloth'].includes(user.organization_category) && (
        <DashboardCloth />
      )}
      </Suspense>
    );
  };

  export default DashboardWrapper;
  